import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import utils from '.';

export interface IRequester extends AxiosInstance {
  get<T = any, R = IRequesterResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R>;
  post<T = any, R = IRequesterResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>;
  put<T = any, R = IRequesterResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>;
  delete<T = any, R = IRequesterResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R>;
  patch<T = any, R = IRequesterResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>;
  getToken?: () => string;
  setToken?: (token: string) => void;
  logout?: () => void;
}
const requester: IRequester = axios.create({
  baseURL: process.env.REACT_APP_REQUESTER_BASE,
  timeout: 30000,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

requester.interceptors.request.use(
  function (config) {
    if (!config?.url?.includes('/users/login')) {
      config.headers.token = utils.queryStringToObject(window.location.href)?.token || requester.getToken?.();
    }
    return config;
  },

  function (error) {
    return Promise.reject(error);
  },
);

// Thêm một bộ đón chặn response
requester.interceptors.response.use(
  function (response): AxiosResponse<IRequesterResponse> {
    return response.data;
  },

  function (error): any {
    const res = error?.response?.data;
    const token = res?.error?.token;

    if (token) {
      const originalRequest = error.config;
      // requester.setToken?.(token);
      // originalRequest.headers.token = token;
      return requester(originalRequest);
    }

    if (error?.response?.data?.error?.logout) {
      return requester.logout?.();
    }
    return Promise.reject(error);
  },
);

export interface IRequesterResponse<T = any> {
  data: T;
  meta: any;
  error: any;
}

export default requester;
